import { render, staticRenderFns } from "./selectmultiple.vue?vue&type=template&id=55f587da&"
import script from "./selectmultiple.vue?vue&type=script&lang=js&"
export * from "./selectmultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports